import React from 'react'
import { useDispatch } from 'react-redux';
import { TextField } from '@shopify/polaris';
import { setToast } from "../../store/actions/configActions";
import './style.css'

const AdvancedOptions = props => {
    const dispatch = useDispatch()

    return (
        <TextField value={props.descriptionValue} type="text" disabled={props.disabled} label={`Description`} placeholder={`Write description here`} onChange={value => {
            if (props.disabled) {
                dispatch(setToast({ active: true, content: `This feature is not available in current plan.`, error: true }))
            } else {
                props.handleChange({ "description": value })
            }
        }} />
    )
}

export default AdvancedOptions
